import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.body};
  margin-top: 20px;
  .fixed-width {
    width: 100%;
    margin-left: -30px;
    /* margin-top: -40px; */
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    margin-left: 0px;
  }
`

const CardBtnWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  margin-top: 50px;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    margin-left: 0px;
  }
  /*new saving card style */
  .card_one {
    background-color: ${({ theme }) => theme.colors.secondPrimary};
    color: ${({ theme }) => theme.colors.white};
    height: 120px;
    width: 90%;

    .flex_wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-around;
    }

    .balance {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.xxl};
      letter-spacing: 1px;
      margin: 0;
      @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
        font-size: ${({ theme }) => theme.fontSize.x1};
      }
    }

    .title {
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.x2};
      font-family: ${({ theme }) => theme.fontFamily.inter};
      line-height: 26px;
      letter-spacing: 0.75px;
      margin: 0;
    }

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 100%;
    }
  }
  .card_two {
    background-color: ${({ theme }) => theme.colors.moneyInterestCard};
    width: 60%;
    height: 125px;
    color: ${({ theme }) => theme.colors.navyBlue};
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }

    .flex_wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      flex-direction: column-reverse;
    }

    .balance {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.x2};
      letter-spacing: 1px;
      margin: 0;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: ${({ theme }) => theme.fontSize.x1};
      }
    }

    .title {
      font-weight: 400;
      font-size: ${({ theme }) => theme.fontSize.x4};
      font-family: ${({ theme }) => theme.fontFamily.inter};
      line-height: 26px;
      letter-spacing: 0.75px;
      margin: 0;
    }

    .icon_wrapper {
      align-self: flex-end;
      margin-top: 1rem;
    }
  }

  /*new saving card style */

  .general-owl-theme {
  }
  .owl-dots {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      display: none;
    }
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .owl-carousel button.owl-dot {
    background: #6e7191;
    color: white;
    border: none;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  .owl-carousel {\
          z-index: 0;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      z-index: 0;
    }
  }
  .owl-carousel button.owl-dot.active {
    background: #2336ff;
    border-radius: 10px;
    margin: 0 5px;
    width: 22px;
    height: 6px;
  }

  .card-img {
    width: 40px;
    height: 40px;
  }

  .btn-container {
    display: flex;
    width: 320px;
    justify-content: space-between;
    margin-top: 3rem;
    margin-left: -5px;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      /* padding-right: 2px; */
      margin: 3rem 0;
    }
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    margin-top: 2rem;
  }
`

const TransactionContainer = styled.div`
  width: 90%;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
  }

  .web-transaction {
    display: block;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    }
  }

  .mobile-transaction {
    display: none;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      display: block;
    }
  }
`

const SavingsWrapper = styled.div`
  width: 30%;
  display: flex;
`

export { Container, CardBtnWrapper, TransactionContainer, SavingsWrapper }
//  LinkWrapper,
